"use strict";

class CustomerAgentProfileController {

    constructor($scope, SSHttpService, SSUtilService, $timeout, SSEoiService, SSAwsService, SSAlertService, SSAppService, SSUserService) {
    	const self = this;

        self.$scope = $scope;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.$timeout = $timeout;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        
        self.PROPERTY_ASSET_TYPE_HERO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_HERO_IMAGE;
        self.PROPERTY_ASSET_TYPE_LOGO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_LOGO_IMAGE;

        self.data = SHOWSUITE.data;
        self.agent_id = SHOWSUITE.data.agent_id;
        self.init();
    }

    init() {
    	const self = this;

        self.agent = null;

        self.getAgentProfile();
    }

    getAgentProfile(){
        const self = this;

        let url = 'brokers/' + self.agent_id;
        let params = {
            format: 1,
            include: 'user, agency, projects'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (responseObj) {
          loading(false);
          if (responseObj instanceof Error) {
            self.SSAlertService.parseAndDisplayError(responseObj);
            let errorData = responseObj.data;
            return;
          }
          if(responseObj.data){
            self.agent = responseObj.data.brokers[0];

          }
          console.log(self.agent);
        });
    }

    getPropertyHeroImageUrl(property_assets){
      const self = this;

      let placehodeer = 'https://via.placeholder.com/880x640';
      
      if(!property_assets){
        return placehodeer;
      }

      let asset = property_assets.find(x => x.type == self.PROPERTY_ASSET_TYPE_HERO_IMAGE);

      if(!asset){
        return placehodeer;
      }

      return self.SSAppService.getAssetUrl(asset.file_uri);
    }

    getPropertyLogoImageUrl(property_assets){
      const self = this;

      if(!property_assets){
        return '/images/placeholder.jpg';
      }

      let asset = property_assets.find(x => x.type == self.PROPERTY_ASSET_TYPE_LOGO_IMAGE);

      if(!asset){
        return '/images/placeholder.jpg';
      }
      
      return self.SSAppService.getAssetUrl(asset.file_uri);
    }


}

CustomerAgentProfileController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', '$timeout', 'SSEoiService', 'SSAwsService', 'SSAlertService', 'SSAppService', 'SSUserService'];
app.controller('CustomerAgentProfileController', CustomerAgentProfileController);
